module.exports = __webpack_public_path__ + "img/Wales.4052e7ce.png";